export const defaultState = () => {
    return {
        uploaded: false
    }
}

const state = defaultState()
export default state
